import { COMMON_REQUEST_DIALOGS } from "@appTypes/dialogs";
import { dialogContents } from "@constants/popups";

export const somethingWentWrongDialog = {
  isSuccess: false,
  dialogType: COMMON_REQUEST_DIALOGS.SOMETHING_WENT_WRONG,
  dialog: dialogContents.somethingWentWrong,
};
